import { render, staticRenderFns } from "./type.vue?vue&type=template&id=2d8e3949"
import script from "./type.vue?vue&type=script&lang=js"
export * from "./type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d8e3949')) {
      api.createRecord('2d8e3949', component.options)
    } else {
      api.reload('2d8e3949', component.options)
    }
    module.hot.accept("./type.vue?vue&type=template&id=2d8e3949", function () {
      api.rerender('2d8e3949', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/competition/type.vue"
export default component.exports